//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getExtractState } from '@/assets/js/dict'
export default {
    created() {
        getExtractState().then(res => {
            this.extractStateList = res;
        })
    },
    data: () => ({
        type: '1',
        loading: false,
        finished: false,
        list: [],
        extractStateList: [],
        withForm: {
            pageIndex: 1,
            pageSize: 10,
            sortName: '',
            sortOrder: '',
            title: '',
            userId: ''
        },
        windVisible: false,
        windInfo: ''
    }),
    methods: {

        getList() {
            this.withForm.userId = getSession('user').id
            this.loading = true;
            this.$get('/pay/user/pay/extract/list', this.withForm, function (res) {
                var newArr = res.data.records;
                if (!newArr || newArr.length === 0) {
                    this.finished = true
                } else {
                    for (var i = 0; i < newArr.length; i++) {
                        if (newArr[i].serviceContent) {
                            newArr[i].serviceContents = eval(newArr[i].serviceContent).toString();
                        } else {
                            newArr[i].serviceContents = ''
                        }
                    }
                    this.list.push(...newArr)
                    this.withForm.pageIndex = this.withForm.pageIndex + 1
                }
                this.loading = false
            })
        },

        //    结算详情
        detail(row) {
            this.windVisible = true;
            this.windInfo = row;
        }

    },
    mounted() {

    }
}
